import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { Table } from "antd";

import "antd/dist/antd.min.css";
import { Resizable } from "react-resizable";
import { theme } from "../../../theme";
import { numberWithCommas } from "../../../shared/utils";
import PaginationComponent from "../Pagination";
import Buttons from "../../atoms/Buttons";
import PageSelect from "./components/PageSelect";
import EmptyBoxComp from "../EmptyBoxComp";
import { TableProps } from "../../atoms/Table";

interface CustomTableProps extends TableProps {
  headerTitle: string;
  data: any;
  totalCount: number;
  pageSize: number;
  onPageChanged?: null | ((page: number) => void);
  onPageSizeChanged?: null | ((pageSize: number) => void);
  onAdditional?: React.ReactNode;
  buttonText?: string;
  buttonFunc?: any;
  deleteButton?: React.ReactNode;
  handleModal: any;
  currentPage: number;
  rowSelection?: any;
  isLoading: boolean;
  isGenerateBanned?: boolean;
  padding?: string;
}
const PaginationTable: React.FC<CustomTableProps> = ({
  headerTitle,
  columns,
  data,
  totalCount,
  onPageChanged,
  onPageSizeChanged,
  pageSize,
  handleModal,
  currentPage,
  onAdditional,
  rowSelection,
  deleteButton,
  buttonFunc,
  buttonText,
  isLoading,
  padding,
  isGenerateBanned,
  ...rest
}) => {
  const [dcolumns, setDcolumns] = useState<any>([]);
  const [components, setComponents] = useState<any>({});
  useEffect(() => {
    setDcolumns(columns);
    setComponents({
      header: {
        cell: ResizeableTitle,
      },
    });
  }, []);

  const ResizeableTitle = (props: any) => {
    const { onMouseUp, onResize, dataIndex, width, style, ...restProps } =
      props;

    if (width === 48) {
      return (
        <Resizable height={0} width={48} handle={<span />}>
          <th {...restProps} />
        </Resizable>
      );
    }

    return (
      <Resizable
        resizeHandles={["e"]}
        width={width}
        height={0}
        handle={
          <span
            className="react-resizable-handle"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
            }}
          >
            <span />
          </span>
        }
        draggableOpts={{ enableUserSelectHack: false }}
        onResize={onResize}
      >
        <th style={{ whiteSpace: "nowrap" }} {...restProps} />
      </Resizable>
    );
  };

  return (
    <Wrapper>
      <TableHeader>
        <TextPlace>{headerTitle}</TextPlace>
        <ButtonWrap>
          {onPageSizeChanged && (
            <div
              style={{
                marginRight: "24px",
                width: "135px",
                display: "flex",
                flexWrap: "nowrap",
                lineHeight: "32px",
              }}
            >
              <PageSelect
                value={pageSize}
                onPageSizeChanged={onPageSizeChanged}
              />
              &nbsp; 개씩 보기
            </div>
          )}
          {onAdditional && (
            <AdditionalButtonWrapper>{onAdditional}</AdditionalButtonWrapper>
          )}
          {!isGenerateBanned && (
            <Buttons
              disabled={isGenerateBanned}
              type="main"
              text={buttonText || "등록하기"}
              onClick={buttonFunc || (() => handleModal("generate"))}
            />
          )}
        </ButtonWrap>
      </TableHeader>
      {isLoading ? (
        <TableContent loading />
      ) : data.length > 0 ? (
        <TableContent
          padding={padding}
          showSorterTooltip={false}
          rowSelection={rowSelection}
          components={components}
          columns={dcolumns}
          dataSource={data}
          pagination={onPageChanged === null ? undefined : false}
          loading={false}
          // scroll={{ x: 1496, y: 496 }}
          scroll={{
            x: true,
            y: "calc(100vh - 464px)",
            scrollToFirstRowOnChange: true,
          }}
          sticky
          rowKey="id"
          size="large"
          {...rest}
        />
      ) : (
        <EmptyBoxComp />
      )}
      {data?.length > 0 && (
        <FooterWrapper>
          <TableFooter>
            <DeleteWrapper>
              {deleteButton}
              <span>
                총 <TotalCount>{numberWithCommas(totalCount)}</TotalCount>
              </span>
            </DeleteWrapper>
            {onPageChanged && (
              <PaginationComponent
                currentPage={currentPage}
                pageSize={pageSize}
                totalCount={totalCount}
                setCurrentPage={(page) => onPageChanged(page)}
              />
            )}
          </TableFooter>
        </FooterWrapper>
      )}
    </Wrapper>
  );
};

const FooterWrapper = styled.div`
  padding: 0px 24px 24px 24px;
  background-color: white;
  border-radius: 0px 0px 16px 16px;
`;

const TextPlace = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #242426;
`;
const ButtonWrap = styled.div`
  display: flex;

  justify-content: flex-end;
`;
const TableContent = styled(Table)<{ padding?: string }>`
  width: 100%;
  padding: ${({ padding }) => padding || "24px 24px 0px"};

  cursor: default;
  overflow-y: hidden;
  border-color: ${theme.colors.gray6};

  .container {
    border: 2px solid skyblue;
    margin: 100px;
  }

  .ant-pagination-total-text {
    position: absolute;
    left: 0;
  }
  .ant-table-row:hover {
    /* color: ${theme.colors.mainPrimary3}; */
    cursor: pointer;
  }

  cursor: default;
  overflow-y: hidden;
  border-color: ${theme.colors.gray6};

  .ant-table-cell .expand-icon {
    border: 0px solid transparent;
  }

  .ant-table-thead > tr {
    height: 48px;
  }
  .ant-table-thead > tr > th {
    padding-left: 12px;
  }
  .ant-table-tbody > tr:hover {
    background-color: white;
  }
  .ant-table-thead > tr > th {
    ${theme.typo.heading.b14};
  }
  .ant-table-row {
    height: 56px;
    cursor: pointer;
  }
  .ant-table-tbody > tr.ant-table-row > tr {
    height: 56px;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: #f8f8f8;
  }
`;
const Wrapper = styled.div`
  background-color: white;
  margin: 40px 0px 0px 0px;
  border-radius: 16px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const AdditionalButtonWrapper = styled.div`
  margin-right: 24px;
  margin-left: 24px;
`;
const TotalCount = styled.span`
  color: ${theme.colors.gray1};
  ${theme.typo.heading.b14};
`;
const DeleteWrapper = styled.div`
  display: flex;
  flex-wrap: no-wrap;
`;
const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 24px;
  border-bottom: 1px solid ${theme.colors.gray7};
  background-color: white;
`;
const TableFooter = styled(TableHeader)`
  min-height: 64px;
  padding: 20px 24px;
  box-shadow: inset 0px 1px 0px #e2e2e2;
  border-bottom: none;
`;
export default PaginationTable;
